<script setup>
import './styles.scss';
import { onMounted, ref } from 'vue';
import AppIcon from 'module/icon/AppIcon.vue';

defineProps({
    job: {
        type: Object,
        required: true,
    },
    company: {
        type: Object,
        required: true,
    },
});

const expanded = defineModel('expanded', { type: Boolean });

const MIN_ITEMS_TO_COLLAPSE = 4;

function setExpanded(isExpanded) {
    expanded.value = isExpanded;
}

const keyfactBoxItemList = ref(null);
onMounted(() => {
    const amountOfItems = keyfactBoxItemList.value.querySelectorAll('li').length;
    if (amountOfItems >= MIN_ITEMS_TO_COLLAPSE) {
        setExpanded(false);
    }
});

</script>

<template>
    <div
        class="m-mobileKeyfactBox"
    >
        <div class="m-mobileKeyfactBox__inner">
            <div class="m-mobileKeyfactBox__companyTitle">
                <template v-if="company.isLinkable">
                    <a
                        class="m-mobileKeyfactBox__companyLink"
                        :href="`/f/${company.slug}`"
                    >
                        {{ company.name }}
                    </a>
                </template>
                <template v-else>
                    {{ company.name }}
                </template>
            </div>
            <div
                class="m-mobileKeyfactBox__keyfactBox"
                :class="{ 'm-mobileKeyfactBox__keyfactBox--collapsed': !expanded }"
            >
                <ul
                    ref="keyfactBoxItemList"
                    class="m-mobileKeyfactBox__keyfactBoxList"
                >
                    <li
                        v-if="job.employmentTypes"
                        class="m-mobileKeyfactBox__keyfactBoxItem"
                    >
                        <AppIcon
                            name="clock"
                            size="medium"
                        />
                        <div class="m-mobileKeyfactBox__keyfactBoxItemInner">
                            {{ job.employmentTypes }}
                        </div>
                    </li>
                    <li
                        v-if="job.salaryRange"
                        class="m-mobileKeyfactBox__keyfactBoxItem"
                    >
                        <AppIcon
                            name="euro"
                            size="medium"
                        />
                        <div class="m-mobileKeyfactBox__keyfactBoxItemInner">
                            {{ job.salaryRange }}
                        </div>
                    </li>
                    <li
                        v-if="job.jobLevel"
                        class="m-mobileKeyfactBox__keyfactBoxItem"
                    >
                        <AppIcon
                            name="briefcase-heart"
                            size="medium"
                        />
                        <div class="m-mobileKeyfactBox__keyfactBoxItemInner">
                            {{ job.jobLevel }}
                        </div>
                    </li>
                    <li
                        v-if="job.isHomeOffice"
                        class="m-mobileKeyfactBox__keyfactBoxItem"
                    >
                        <AppIcon
                            name="house"
                            size="medium"
                        />
                        <div class="m-mobileKeyfactBox__keyfactBoxItemInner">
                            Homeoffice möglich
                        </div>
                    </li>
                    <li
                        v-if="job.locations"
                        class="m-mobileKeyfactBox__keyfactBoxItem"
                    >
                        <AppIcon
                            name="map-pin"
                            size="medium"
                        />
                        <div class="m-mobileKeyfactBox__keyfactBoxItemInner">
                            {{ job.locations }}
                        </div>
                    </li>
                    <li
                        v-if="job.date"
                        class="m-mobileKeyfactBox__keyfactBoxItem"
                    >
                        <AppIcon
                            name="calendar"
                            size="medium"
                        />
                        <div class="m-mobileKeyfactBox__keyfactBoxItemInner">
                            {{ job.date }}
                        </div>
                    </li>
                    <template v-if="!job.isChiffre">
                        <li class="m-mobileKeyfactBox__keyfactBoxItem m-mobileKeyfactBox__aboutCompanyHeadline">
                            Über das Unternehmen
                        </li>
                        <li
                            v-if="!job.companyIsEmploymentAgency && company.employees"
                            class="m-mobileKeyfactBox__keyfactBoxItem"
                        >
                            <AppIcon
                                name="person-group"
                                size="medium"
                            />
                            <div class="m-mobileKeyfactBox__keyfactBoxItemInner">
                                {{ company.employees }} Mitarbeiter*innen
                            </div>
                        </li>
                        <li
                            v-if="company.mainLocation"
                            class="m-mobileKeyfactBox__keyfactBoxItem"
                        >
                            <AppIcon
                                name="map-pin"
                                size="medium"
                            />
                            <div class="m-mobileKeyfactBox__keyfactBoxItemInner">
                                {{ company.mainLocation }}
                            </div>
                        </li>
                    </template>
                </ul>
                <button
                    id="keyfact-toggle-button"
                    :class="{
                        'm-mobileKeyfactBox__showMore': !expanded,
                        'm-mobileKeyfactBox__showLess': expanded,
                    }"
                    @click="setExpanded(!expanded)"
                >
                    {{ expanded ? 'Weniger' : 'Mehr' }} anzeigen
                </button>
            </div>
        </div>
    </div>
</template>

<style lang="scss">
@use "styles";
</style>
